<template>
  <div class="upload">
    <el-button
      type="primary"
      class
      size="mini"
      icon="el-icon-upload"
      @click="childclick"
    >
      <slot>{{ name ? name : '导入' }}</slot>
    </el-button>
    <div class="uploadTip" v-show="uploadHide">
      <div class="head">
        <p>文件上传</p>
        <p>
          <i class="el-icon-close" @click="handelClose"></i>
        </p>
      </div>
      <!-- <form enctype="multipart/form-data" ref='fileForm'>
        <input type="file" ref="upFile" name="files" multiple="multiple">
      </form>-->
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="baseURL + connectString"
        :before-upload="beforeUpload"
        :before-remove="removeList"
        :data="formdata"
        :on-exceed="handleExceed"
        :on-success="handleSuccess"
        :limit="1"
        :file-list="fileList"
        :auto-upload="false"
        :on-error="error"
      >
        <el-button slot="trigger" class="file-btton" size="small" type="primary"
          >选取文件</el-button
        >
        <div class="tips" v-if="isTipsFlage == '1'">
          1.若上传的文件包括总部人员和项目人员，则上传后，将自动删除原有的所有人员信息，并将新的人员信息导入；<br />2.若上传的文件只包含总部人员，则上传后，将自动删除原有的所有总部人员信息，并将新的人员信息导入；<br />3.若上传的文件只包含项目人员，则上传后，将自动删除原有的所有项目人员信息，并将新的人员信息导入。
        </div>
        <div class="tips" v-if="isTipsFlage == '2'">
          上传文件后，将删除本项目原有的所有人员信息，并将新的人员信息导入。
        </div>
      </el-upload>
      <div class="foot">
        <div class="btn">
          <!-- <ps-sure @click.native="submitUpload"></ps-sure> -->
          <el-button type="primary" size="mini" @click="submitUpload"
            >上传</el-button
          >
          <!-- <ps-cancel @click.native="handelClose"></ps-cancel> -->
          <el-button type="info" size="mini" @click="handelClose"
            >关闭</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { devEnvironment, proEnvironment } from '@/assets/js/division';
// import {ImportantDoc} from '@/service/ImportantDoc';
//import {ImportantDoc} from '@/service/PropertyContractRecordController/ImportantDocList';
export default {
  computed: {
    ...mapState(['token']),
  },
  props: [
    'data',
    'connectString',
    'show',
    'befHandle',
    'importType',
    'name',
    'upLoadNum',
    'isTipsFlage',
  ],
  data() {
    return {
      uploadHide: false,
      fileList: [],
      resList: [],
      baseURL: '',
      formdata: {},
      loading: '',
    };
  },
  created() {},
  mounted() {},
  watch: {
    data: {
      handler() {
        this.formdata = this.data;
      },
      deep: true,
    },
    name: {
      handler() {},
      deep: true,
    },
    importType: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    childclick() {
      if (this.importType === 'report') {
        this.$message({
          message:
            '请先导出所有数据，更新完善所有信息后再导入。导入的数据会覆盖原有数据，请谨慎操作。',
          type: 'warning',
        });
      }
      if (this.befHandle && !this.befHandle()) {
        return;
      }
      //this.uploadHide = true;
      if (process.env.NODE_ENV === 'development') {
        this.baseURL = devEnvironment;
      } else if (process.env.NODE_ENV === 'production') {
        this.baseURL = 'szwyweb/';
      }
      this.uploadHide = true;
      if (this.upLoadNum) {
        console.warn('this.upLoadNum', this.upLoadNum);
        console.warn('fileName', this.data['fileName']);
        this.data['fileName'] = `${this.data['fileName']}${this.upLoadNum}`;
        // this.data['fileName'] = `${this.data['fileName']}`;
      }
      this.formdata = this.data;
      console.warn('11111', this.formdata);
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    beforeUpload() {
      this.loading = this.$loading({
        lock: true,
        text: '上传中，请稍后！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    },
    handleSuccess(res, file) {
      this.loading.close();
      if (
        JSON.stringify(res) === '[]' ||
        res === 'SUCCESS' ||
        res === '导入成功' ||
        (res !== null && res.err !== null && res.length === 0) ||
        res.SUCCESS === 'SUCCESS' ||
        res.docCode
      ) {
        if (this.upLoadNum) {
          res['upLoadNum'] = this.upLoadNum;
        }
        this.fileList = [];
        this.$emit('flash', res);
        this.handelClose();
        this.$message({
          type: 'success',
          message: '上传成功',
        });
      } else {
        this.$refs.upload.clearFiles();
        if (res.success) {
          this.$emit('flash', res);
        } else {
          if (res.err) {
            this.$message({
              message: '上传失败，' + res.err,
              type: 'error',
              duration: 5000,
            });
          } else {
            this.$message({
              message: '上传失败，' + res,
              type: 'error',
              duration: 5000,
            });
          }
        }
      }
    },
    error(res, file) {
      this.loading.close();
      this.$refs.upload.clearFiles();
      if (JSON.parse(res.message).error_respone.errMsg) {
        this.$message({
          message: '上传失败，' + JSON.parse(res.message).error_respone.errMsg,
          type: 'error',
          duration: 5000,
        });
      } else {
        this.$message({
          message: '上传失败，' + JSON.parse(res.message).message,
          type: 'error',
          duration: 5000,
        });
      }
    },
    handelClose() {
      this.uploadHide = false;
    },
    fileUp(file) {
      this.$refs.upload.submit();
      this.$emit('click', file);
      return false;
    },
    removeList(file) {
      this.$emit('removeFile', this.configStr);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
</script>
<style lang="scss">
input[type='file'] {
  display: none;
}
</style>
<style lang="scss" scoped>
.upload {
  display: inline-block;
  margin-left: 10px;

  .file-btton {
    width: 90%;
    margin: 0;
  }

  .uploadTip {
    //height: 200px;
    width: 400px;
    background: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -100px;
    margin-left: -200px;
    border: 1px solid #ccc;
    z-index: 100;
    border-radius: 10px;
    overflow: hidden;

    .head {
      line-height: 30px;
      height: 30px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      background: #f3f5f9;
    }

    .tips {
      padding: 0 20px;
      color: red;
      margin-top: 5px;
    }

    .foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #f3f5f9;

      .btn {
        float: right;
        margin-right: 10px;
      }
    }
  }
}
</style>
